import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * SP-7b — Bottone toggle tema chiaro/scuro nell'header.
 * Mostra 🌙 in light (per passare a dark) e ☀️ in dark (per tornare a light).
 */
export function ThemeToggle() {
  const { t } = useTranslation('shell');
  const { mode, toggleTheme } = useTheme();
  const nextLabel = mode === 'light' ? t('header.theme_dark') : t('header.theme_light');
  return (
    <button
      type="button"
      className="btn btn-icon btn-sm btn-ghost-secondary"
      onClick={toggleTheme}
      title={nextLabel}
      aria-label={nextLabel}
    >
      <i className={`bi ${mode === 'light' ? 'bi-moon-stars' : 'bi-sun'} fs-18`} />
    </button>
  );
}
